class ProductSelector extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener(
      'submit',
      this.onSubmitHandler.bind(this)
    );
    this.submitButton = this.form.querySelector('[name="add"]');
    this.actions = this.submitButton.parentNode;
    this.cartDrawer = document.querySelector('cart-drawer');
    this.variants = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    );

    this.processOrderDeadlineText();

    this.addEventListener('change', event => {
      if (!event.target || !event.target.classList.contains('hidden')) this.onVariantChange(event);
    });

    this.initOptionsSliders();
    this.initOptionsAnimation();

    window.addEventListener('resize', () => {
      this.initOptionsSliders();
    });

    this.initSize();

    var top = document.querySelector('header').clientHeight + 10;
    window.addEventListener('scroll', () => {
      if (this.actions.getBoundingClientRect().top <= top) {
        if (!this.actions.classList.contains('sticky')) {
          this.actions.style.setProperty('--top', document.querySelector('header').clientHeight + 'px');
          this.actions.classList.add('sticky');
        }
      } else {
        this.actions.classList.remove('sticky');
      }
    }, { passive: true });
  }

  /**
   * Initializes the size selection for a product based on URL parameters or local storage.
   * If a variant ID is present in the URL query string, it selects the appropriate size options
   * for that variant. If no variant ID is found in the URL, the previously selected size is
   * retrieved from local storage and applied.
   *
   * @return {void} Does not return a value.
   */
  initSize() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantIdFromUrl = urlParams.get('variant');

    if (variantIdFromUrl) {
      const variant = this.variants.find(v => v.id == variantIdFromUrl);
      if (variant) {
        variant.options.forEach((optionValue, index) => {
          const selector = `.product__form-group:nth-of-type(${index + 1}) [value="${optionValue}"]`;
          const optionEl = this.querySelector(selector);
          if (optionEl) optionEl.click();
        });

        if (variant.option1) {
          localStorage.setItem('size', parseInt(variant.option1));
        }
      }
    } else {
      let size = localStorage.getItem('size');
      if (size) {
        let el = this.querySelector(`.product__form-group [value="${size}"]`);
        if (el) el.click();
      }
    }
  }

  initOptionsSliders() {
    const sliders = document.querySelectorAll('.swiper.product__radios-wrapper');
    sliders.forEach(slider => {

      if (slider.swiper && slider.swiper.initialized) {
        slider.swiper.destroy(true, true);
        slider.parentNode.classList.remove('with-navigation');
      }

      const slides = slider.querySelectorAll('.swiper-slide');
      const visibleSlides = Helper.visibleSidesCount(slider, slides);

      let config = {
        draggable: true,
        slidesPerView: 'auto',
        spaceBetween: 7,
        on: {
          slideChange: (swiper) => {
            setTimeout(() => {
              const radiosWrapper = swiper.el.querySelector('.product__radios');

              if(radiosWrapper) {
                Helper.moveToActiveItem(radiosWrapper, '.radio.checked');
              }
            }, 400)
          }
        }
      }

      if(visibleSlides < slides.length) {
        config['navigation'] = {
          nextEl: slider.parentNode.querySelector('.swiper-button-next'),
          prevEl: slider.parentNode.querySelector('.swiper-button-prev')
        };

        slider.parentNode.classList.add('with-navigation');
        slider.swiper = new Swiper(slider, config);
      }

      const radiosWrapper = slider.querySelector('.product__radios');

      if(radiosWrapper) {
        Helper.moveToActiveItem(radiosWrapper, '.radio.checked');
      }
    })
  }

    // remove order deadline text if the replacement metafield is not empty
  processOrderDeadlineText() {
      const popupBlockerObserver = new MutationObserver(mutations => {
          mutations.forEach(mutation => {
              mutation.addedNodes.forEach(node => {
                  if(this.submitButton.parentNode.dataset?.replacement?.length > 0 && node?.classList?.contains('trustblox-1-timer-wrap')) {
                      node.remove();
                  }
              });
          });
      });

      popupBlockerObserver.observe(document.body, {
          childList: true,
          subtree: true
      });
  }

  onSubmitHandler(event) {
    event.preventDefault();

    this.submitButton.classList.add('disabled');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const formData = new FormData(this.form);
    formData.append(
      'sections',
      this.cartDrawer
        .getSectionsToRender()
        .map((section) => section.section)
    );
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        this.cartDrawer.renderContents(response);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.submitButton.classList.remove('disabled');
      });
  }

  handleErrorMessage(errorMessage = false) {
    const errorWrapper = this.querySelector('[data-error-wrapper]');
    if (!errorWrapper) return;
    errorWrapper.classList.toggle('hidden', !errorMessage);
    errorWrapper.textContent = errorMessage || '';
  }

  updateText(target) {
    if (!target) return;
    const group = target.closest('.js-group');
    if (!group) return;
    const textElement = group.querySelector('.js-selected-value');
    if (!textElement) return;
    textElement.textContent = target.value;
  }

  initOptionsAnimation() {
    const productRadios = this.querySelectorAll('.product__radios-wrapper .swiper-wrapper');
    const moveToActivatedItem = (event) => Helper.moveToActivatedItem(event.target.parentNode);
    const moveToActiveItem = (event) => Helper.moveToActiveItem(event.target, '.radio.checked');

    productRadios.forEach(radioWrapper => {
      const radios = radioWrapper.querySelectorAll('.radio');

      radios.forEach(radio => {
        radio.removeEventListener('mouseover', moveToActivatedItem);
        radio.addEventListener('mouseover', moveToActivatedItem);

        if(radio.classList.contains('checked')) {
          Helper.moveToActivatedItem(radio);
        }
      })

      radioWrapper.removeEventListener('mouseleave', moveToActiveItem);
      radioWrapper.addEventListener('mouseleave', moveToActiveItem);
    })
  }

  setTargetParentActiveClass(parent) {
    if(!parent || !parent.classList.contains('radio')) {
      return;
    }

    this.querySelectorAll('.radio').forEach(item => item.classList.remove('checked'));

    parent.classList.add('checked');

    Helper.moveToActivatedItem(parent);
  }

  onVariantChange(event) {
    if (event.target.type === 'number') return;

    this.setTargetParentActiveClass(event.target.parentNode);
    this.updateText(event.target);
    this.updateOptions();
    this.updateVariant();
    this.toggleAddButton(false, '');
    this.handleErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '');
      this.setUnavailable();

      return;
    }

    let size = this.currentVariant.option1;
    if (size) localStorage.setItem('size', parseInt(size));

    if (!this.currentVariant.available) {
      ``;
      this.toggleAddButton(true, window.variantStrings.soldOut);
    }

    if(this.submitButton?.parentNode?.parentNode?.dataset?.replacement?.length > 0) {
      this.toggleAddButton(true, this.submitButton.parentNode.parentNode.dataset.replacement);
    }

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.updateMetaSwatches();
    this.renderProductInfo();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('input[type="radio"]:not(.hidden):checked, select'),
      (el) => el.value
    );
  }

  updateVariant() {
    this.currentVariant = this.variants.find((variant) => {
      return !variant.options
        .map((option, index) => this.options[index] === option)
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media)
      return;

    const productMedia = document.querySelector('product-media');
    productMedia.setActiveMedia(
      this.currentVariant.featured_media.id
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id
    );
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`
    );
  }

  updateVariantInput() {
    const input = this.querySelector('[name="id"]');
    input.value = this.currentVariant.id;
  }

  updateMetaSwatches() {
    this.querySelectorAll('.js-meta-swatch').forEach((swatch) => {
      const variants = swatch.dataset.variants.split('|');

      variants.forEach((variant) => {
        let [title, available] = variant.split('::');
        available = available == 'true' ? true : false;
        if (title != this.currentVariant.title) return;
        swatch.classList.toggle('meta-swatch--sold-out', !available);
      });
    });
  }

  setUnavailable() {
    const submitButton = this.querySelector('[name="add"]');
    const price = this.querySelector(
      `#price-${this.dataset.sectionId}`
    );

    if (!submitButton) return;
    submitButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  toggleAddButton(disable, text) {
      console.log('toggleAddButton', disable, text);
    const submitButton = this.querySelector('[name="add"]');

    if (disable) {
      submitButton.setAttribute('disabled', 'disabled');
      if (text) submitButton.textContent = text;
      if (this.currentVariant) document.getElementById('mhaRnProduct').style.display = 'block';
    } else {
      submitButton.removeAttribute('disabled');
      submitButton.textContent = window.variantStrings.addToCart;
      document.getElementById('mhaRnProduct').style.display = 'none';
    }
  }

  renderProductInfo() {
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id
    );
    params.append('section_id', this.dataset.sectionId);

    fetch(`${this.dataset.url}?${params.toString()}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(
          responseText,
          'text/html'
        );
        const destinationPrice = document.querySelector(
          `#price-${this.dataset.sectionId}`
        );
        const sourcePrice = html.querySelector(
          `#price-${this.dataset.sectionId}`
        );

        if (destinationPrice && sourcePrice) {
          destinationPrice.classList.remove('visibility-hidden');
          destinationPrice.innerHTML = sourcePrice.innerHTML;
        }
      });
  }

  updateSticky() {

  }
}

customElements.define('product-selector', ProductSelector);
